import { Button, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { checkAllValidationNotInProgress } from "../../services/validateAPIService";
import store from "../../stateManagement/store";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";


const ValidateForm = (props: {
	handleValidateClick: (userName: string, password: string) => any;
}): JSX.Element => {
	const { translate } = usePortalTranslation();
	const CUR_COMPONENT = "Validate API";
	const userNameRef = useRef<HTMLInputElement>(null);
	const passwordRef = useRef<HTMLInputElement>(null);
	const allValidationStatus = useSelector(() => store.getState().validateAPIState?.validationStatus);
	const [loading, setLoading] = useState<boolean>(false);

	const handleClick = async(event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault();
		setLoading(true);
		const userName: string = userNameRef.current?.value ?? "";
		const password: string = passwordRef.current?.value ?? "";
		const ans = await props.handleValidateClick(userName, password);
		if(ans==-1){
			setLoading(false)
		}
	};

	useEffect(() => {
		if (Object.keys(allValidationStatus).length > 0)
			setLoading(() => !checkAllValidationNotInProgress(allValidationStatus) ? true : false);
	}, [allValidationStatus])


	return (
		<form className="validateApi-form">
			<TextField
				required
				inputRef={userNameRef}
				id="outlined-required"
				label= {translate(TranslationEnum.validate_api,"Username")}
				disabled={loading}
			/>
			<TextField
				inputRef={passwordRef}
				id="outlined-password-input"
				label={translate(TranslationEnum.validate_api,"Password")}
				type="password"
				required
				disabled={loading}
			/>
			<Button
				variant="outlined"
				type="submit"
				onClick={handleClick}
				disabled={loading}
			>
				{
					loading ? translate(TranslationEnum.validate_api,"Validating...") : translate(TranslationEnum.validate_api,"Validate")
				}
			</Button>
		</form>
	);
};
export default ValidateForm;
